import axios from 'axios'
// eslint-disable-next-line import/no-extraneous-dependencies
import qs from 'qs'
import { Message } from 'element-ui'

const service = axios.create({
  baseURL: process.env.VUE_APP_REQUEST_URL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'content-type': 'application/json'
  },
  timeout: 300000,
  method: 'post'
})

axios.defaults.withCredentials = true

service.interceptors.request.use(
  (config) => {
    if (!config.notUseQstring) config.data = qs.parse(qs.stringify(config.data || '{}'))
    
    console.log('url :>> ', config.url)
    console.log('接口参数 :>> ', config, config.data)
    return config
  },
  (error) => Promise.reject(error)
)

service.interceptors.response.use(
  (res) => {
    const { desc, status } = res.data
    if (status !== 200) {
      Message.error(desc)
      return new Error(desc)
    }
    return res.data
  },
  (error) => {
    const errorMessage =
      error.response.status === 500 ? 'uncatch error' : error.response.data.message

    if (error.response.status === 401) {
      Message.error('用户未授权')

      localStorage.login = false
      window.location.reload()
    }

    Message.error(errorMessage)
    return Promise.reject(error)
  }
)

export default service
